<template>
  <div>
    <section
      v-for="(nearestBadge, idx) in this.getNearestBadge"
      :key="`nearestBadge${idx}`"
      class="text-white py-3 d-flex justify-content-center"
    >
      <div v-if="nearestBadge" class="container px-3">
        <div
          class="badges-container d-flex align-items-center px-3  p-3 flex-column flex-sm-row shadow-sm bg-primary rounded"
        >
          <span class="px-4">
            Nearest Badge
          </span>
          <b-img
            v-if="nearestBadge.image"
            :src="nearestBadge.image"
            width="100px"
            fluid
            class="badge-image mr-1 h-auto"
          ></b-img>
          <i v-else class="material-icons cursor h1 m-0 p-0 text-warning ">
            local_police
          </i>
          <div class="flex-fill pt-3 pt-sm-0">
            <p class="small mb-1 ">
              {{ nearestBadge.name }}
            </p>
            <p class="small mb-1">
              {{ nearestBadge.description }}
            </p>
            <div class="badge-item flex-fill pt-3 pt-sm-0">
              <div class="badge-info d-flex flex-column justify-content-center">
                <div class="badge-progress">
                  <label class="progress-text text-white"
                    >{{ nearestBadge.score }}/{{ nearestBadge.score_requirement }}</label
                  >
                  <b-progress
                    :value="calculateNearestBadgeProgress(nearestBadge)"
                    :max="100"
                    variant="warning"
                    class="progress-parent"
                  ></b-progress>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      v-for="(badge, idx) in badges"
      :key="idx"
      class="d-flex justify-content-center w-100 my-2"
    >
      <div v-if="badge" class="container px-3">
        <div
          class="bg-white shadow-sm rounded flex-column-reverse flex-sm-row badges-container d-flex flex-wrap justify-content-center align-items-center p-3"
        >
          <div class="badge-item flex-fill pt-3 pt-sm-0">
            <div class="badge-info d-flex flex-column justify-content-center">
              <div>{{ badge.name }}</div>
              <div class="small">{{ badge.description }}</div>
              <div class="badge-progress">
                <label class="progress-text">{{ badge.score }}/{{ badge.score_requirement }}</label>
                <b-progress
                  :value="calculateBadgeProgress(badge)"
                  :max="100"
                  variant="warning"
                ></b-progress>
              </div>
            </div>
          </div>
          <b-img
            v-if="badge.image"
            :src="badge.image"
            width="100px"
            fluid
            class="badge-image ml-2 h-auto filter-gray"
          ></b-img>
          <i v-else class="material-icons cursor h1 m-0 p-0 text-secondary">
            local_police
          </i>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    badges: Array,
  },
  computed: {
    getNearestBadge() {
      if (!this.badges || this.badges.length === 0) return null;

      return [
        this.badges.reduce((nearestBadge, badge) => {
          const scoreDiff = badge.score_requirement - badge.score;
          const nearestScoreDiff = nearestBadge.score_requirement - nearestBadge.score;
          return scoreDiff >= 0 && scoreDiff < nearestScoreDiff ? badge : nearestBadge;
        }, this.badges[0]),
      ];
    },
    calculateNearestBadgeProgress() {
      return (nearestBadge) => {
        return (nearestBadge.score / nearestBadge.score_requirement) * 100;
      };
    },
    calculateBadgeProgress() {
      return (badge) => {
        return (badge.score / badge.score_requirement) * 100;
      };
    },
  },
};
</script>

